module.exports = __webpack_public_path__ + "img/grid-sample6.aa203ecd.jpg";